var map = {
	"./pr-1.png": "61b2",
	"./pr-2.png": "2c59",
	"./pr-3.png": "73ce",
	"./pr-4.png": "efbc",
	"./pr-5.png": "dd37",
	"./pr-6.png": "8d17"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "97aa";